<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2020-06-14 16:39:35
 * @LastEditTime: 2022-04-22 11:55:44
 * @FilePath: \raacfold\src\views\Contact.vue
-->
<template>
    <div>
        <div >
            <el-scrollbar :style="{height: winHeight}" class="baimo-scrollbar">
                <h3 style="padding-left: 30px;">Contact</h3>
        <hr style="margin-bottom:0px;">
                <el-container class="container">
                    <el-main>
                        <table id="aa_table" class="table table-striped table-bordered">
                            <tbody><tr>
                                <td><b>Email</b></td>
                                <td>yczuo@imu.edu.cn</td>
                            </tr>
                            <tr>
                                <td><b>Email</b></td>
                                <td>baimoc@163.com</td>
                            </tr>
                            <tr>
                                <td><b>Address</b></td>
                                <td>Zuo Lab ,College of life sciences， Inner Mongolia University, Hohhot, 010021, China</td>
                            </tr>
                            <tr>
                                <td><b>Website</b></td>
                                <td><a href="http://bioinfor.imu.edu.cn">http://bioinfor.imu.edu.cn</a></td>
                            </tr>
                            </tbody></table>
                    </el-main>
                </el-container>

            </el-scrollbar>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Contact",
        data (){
            return{
                winHeight: window.innerHeight - 91 + "px",
            }
        },
    }
</script>

<style scoped>

</style>
